import { render } from "./EvaluationContentModel.vue?vue&type=template&id=98819e08"
import script from "./EvaluationContentModel.vue?vue&type=script&lang=js"
export * from "./EvaluationContentModel.vue?vue&type=script&lang=js"

import "./EvaluationContentModel.vue?vue&type=style&index=0&id=98819e08&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__